/**
 * The assumed initial width of the viewport (in pixels) that the provider will use to initialize
 * its state in the case that it is pre-rendered on the server.
 */
export const InitialWindowSize = 1200;
